import { AppServices } from '@singularsystems/neo-core';
import CatalogueReportingApiClient from './ApiClients/Catalogues/ReportingApiClient';
import GeneralApiClient from './ApiClients/Catalogues/GeneralApiClient';
import GenericApiClient from './ApiClients/Catalogues/GenericApiClient';
import PipelineApiClient from './ApiClients/Catalogues/PipelineApiClient';
import InvestmentSetupApiClient from './ApiClients/InvestmentSetupApiClient';
import CatalogueInvestmentApiClient from './ApiClients/Catalogues/InvestmentApiClient';
import InvestorApiClient from './ApiClients/InvestorApiClient';
import IssuerApiClient from './ApiClients/IssuerApiClient';
import { DomainTypes } from './DomainTypes';
import CatalogueEditService from './Services/CatalogueEditService';
import DataCache from './Services/DataCache';
import { NeoServicesTypes } from '@singularsystems/neo-react-services';
import AuditApiClient from './ApiClients/AuditApiClient';
import IssuerInvestmentApiClient from './ApiClients/IssuerInvestmentApiClient';
import InvestorInvestmentApiClient from './ApiClients/InvestorInvestmentApiClient';
import InvestmentApiClient from './ApiClients/InvestmentApiClient';
import IssuerInvestmentCache from './Services/IssuerInvestmentCache';
import ConfigApiClient from './ApiClients/ConfigApiClient';
import ImagesApiClient from './ApiClients/ImagesApiClient';
import ContactApiClient from './ApiClients/ContactApiClient';
import DashboardApiClient from './ApiClients/DashboardApiClient';
import DividendProcessingApiClient from './ApiClients/DividendProcessingApiClient';
import LetterAuthorisationApiClient from './ApiClients/LetterAuthorisationApiClient';
import PaymentExportApiClient from './ApiClients/PaymentExportApiClient';
import SystemMaintenanceApiClient from './ApiClients/SystemMaintenanceApiClient';
import InvestorInvestmentApprovalApiClient from './ApiClients/InvestorInvestmentApprovalApiClient';
import InternalApproverApiClient from './ApiClients/InternalApproverApiClient';
import UserApiClient from './ApiClients/UserApiClient';
import DocumentsApiClient from './ApiClients/DocumentsApiClient';
import PortalUserApiClient from './ApiClients/PortalUserApiClient';
import InvestorInvestmentNoticeApiClient from "./ApiClients/InvestorInvestmentNoticeApiClient";
import LogApiClient from "./ApiClients/LogsApiClient";
import ExportApiClient from "./ApiClients/ExportApiClient";
import ReportingApiClient from "./ApiClients/ReportingApiClient";
import ImportApiClient from './ApiClients/ImportApiClient';

export const DomainAppModule = new AppServices.Module("Domain", container => {

    // Api Clients
    container.bind(DomainTypes.ApiClients.Audit).to(AuditApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.CatalogueGeneric).to(GenericApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.CatalogueGeneral).to(GeneralApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.InvestmentSetup).to(InvestmentSetupApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.CatalogueReporting).to(CatalogueReportingApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.CatalogueInvestment).to(CatalogueInvestmentApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.CataloguePipeline).to(PipelineApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.DashboardApiClient).to(DashboardApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.Investor).to(InvestorApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.Issuer).to(IssuerApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.IssuerInvestment).to(IssuerInvestmentApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.InvestorInvestment).to(InvestorInvestmentApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.Investment).to(InvestmentApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.LetterAuthorisation).to(LetterAuthorisationApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.Logs).to(LogApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.Config).to(ConfigApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.ImagesApiClient).to(ImagesApiClient);
    container.bind(DomainTypes.ApiClients.Contact).to(ContactApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.DividendProcessing).to(DividendProcessingApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.PaymentExport).to(PaymentExportApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.SystemMaintenance).to(SystemMaintenanceApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.InvestorInvestmentApproval).to(InvestorInvestmentApprovalApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.InvestorInvestmentNotice).to(InvestorInvestmentNoticeApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.User).to(UserApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.InternalApprover).to(InternalApproverApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.PortalUser).to(PortalUserApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.Documents).to(DocumentsApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.ExportApiClient).to(ExportApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.Reporting).to(ReportingApiClient).inSingletonScope();
    container.bind(DomainTypes.ApiClients.Import).to(ImportApiClient).inSingletonScope();
    
    // Services
    container.bind(NeoServicesTypes.Catalogue.CatalogueEditService).to(CatalogueEditService).inSingletonScope();
    container.bind(DomainTypes.Services.DataCache).to(DataCache).inSingletonScope();
    container.bind(DomainTypes.Services.IssuerInvestmentCache).to(IssuerInvestmentCache).inSingletonScope();
});

export const DomainTestModule = new AppServices.Module("Domain", container => {
    // bind test types
});